module.exports = __webpack_public_path__ + "media/images/front/apple-touch-icon-3055ebaca9da4ac3eca62a8192b21c15.png";